import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { withStyles } from '../../mui-styles-bridge.js';

const styles = {
  snackbar: {
    maxWidth: '500px',
    width: '90%',
    margin: '0 auto',
    zIndex: 9999,
  },
};

class RequiredFieldsSnackbar extends React.Component {
  constructor(props) {
    super(props);
    this.timer = null;
  }

  componentDidMount() {
    this.setAutoCloseTimer();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open && this.props.open) {
      this.setAutoCloseTimer();
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  setAutoCloseTimer = () => {
    if (this.props.open) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.props.onClose();
      }, 6000);
    }
  };

  render() {
    const {
      classes,
      open,
      onClose,
      requiredList = [],
      requiredListTable = {},
    } = this.props;

    if (!open) return null;

    // Count total required fields
    const requiredFieldsCount =
      requiredList.length + Object.keys(requiredListTable).length;

    // Create message based on count
    const message =
      requiredFieldsCount === 1
        ? 'Please answer 1 required question before submitting.'
        : `Please answer ${requiredFieldsCount} required questions before submitting.`;

    return (
      <Snackbar
        open={open}
        onClose={onClose}
        className={classes.snackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={6000}
        sx={{
          zIndex: 9999,
          marginTop: '80px',
          '& .MuiSnackbarContent-root': {
            zIndex: 9999,
          },
        }}
      >
        <Alert
          onClose={onClose}
          severity="error"
          sx={{
            width: '100%',
            zIndex: 9999,
            border: '2px solid #d32f2f',
            boxShadow: 'none',
            backgroundColor: '#ffebee',
            '& .MuiAlert-icon': {
              color: '#d32f2f',
            },
            '& .MuiAlert-message': {
              color: '#c62828',
              fontWeight: 600,
            },
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    );
  }
}

export default withStyles(styles)(RequiredFieldsSnackbar);
